<div mat-dialog-content>
    <div class="row">
        <div class="col-12">
            <form class="row" [formGroup]="productoForm">
                <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                    <h3 class="text-left">Nuevo Producto</h3>
                </div> <hr><br>
                <div class="col-sm-12">
                    <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                        <h5 class="text-left">Datos del Producto</h5>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                        <mat-form-field [floatLabel]="'always'">
                            <mat-label>Nombre Interno</mat-label>
                            <input matInput formControlName="nomInterno"
                                placeholder="Nombre Interno" type="text" id="nomInterno"
                                maxlength="40"
                                oninput="this.value = this.value.toUpperCase()">
                                <!-- onkeypress="return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32 || event.charCode == 209 || event.charCode == 241))" -->
                            <mat-error
                                *ngIf="productoForm.get('nomInterno').hasError ('required')">
                                <strong>*Este campo es obligatorio.</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12">
                        <div class="row">
                            <div class='col-sm-12 col-md-6 col-xl-6 mt-2'>
                                <mat-form-field [floatLabel]="'always'">
                                    <mat-label>No. Identificación (Opcional)</mat-label>
                                    <input matInput formControlName="noIdentificacion"
                                        placeholder="Codigo Interno (Opcional)" maxlength="15"
                                        oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.toUpperCase()">
                                </mat-form-field>
                            </div>

                            <div class='col-sm-12 col-md-6 col-xl-6 mt-2'>
                                <mat-form-field [floatLabel]="'always'">
                                    <mat-label>Precio Unitario </mat-label>
                                    <input matInput formControlName="precioUnitario"
                                        placeholder="Precio Unitario" maxlength="18" 
                                        currencyMask
                                        (ngModelChange)="limitarNegativos($event)"
                                        >
                                        <mat-error
                                        *ngIf="productoForm.get('precioUnitario').hasError ('required')">
                                        <strong>*Este campo es obligatorio.</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                        <mat-form-field [floatLabel]="'always'">
                            <mat-label>Descripción</mat-label>
                            <textarea matInput formControlName="descripcion"
                                oninput="this.value = this.value.toUpperCase()"
                                placeholder="Descripción" type="text" > </textarea>
                            <mat-error
                                *ngIf="productoForm.get('descripcion').hasError ('required')">
                                <strong>*Este campo es obligatorio.</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                        <form [formGroup]="cuentaPredialForm">
                            <div formArrayName="cuentasPrediales">
                              <div *ngFor="let cuentaPredial of cuentasPrediales.controls; let i = index">
                                <div [formGroupName]="i" class="form-row">
                                  <mat-form-field appearance="fill" class="input-field">
                                    <mat-label>Número de Cuenta Predial</mat-label>
                                    <input matInput formControlName="numeroCuentaPredial" placeholder="Ej. 123456789" (input)="imprimirCuentaPredial($event)" minlength="9" maxlength="9" pattern="[0-9]*"/>
                                    <mat-error *ngIf="cuentasPrediales.controls[i].controls.numeroCuentaPredial.errors">
                                      El número de cuenta predial es inválido.
                                    </mat-error>
                                    <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Ejemplo: 123456789</mat-hint>
                                  </mat-form-field>
                                  <button mat-icon-button color="warn" (click)="eliminarCuentaPredial(i)">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <button mat-raised-button color="primary" type="button" (click)="agregarCuentaPredial()">Agregar Cuenta Predial</button>
                        </form>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-8' style='margin-bottom: 20px;'>
                        <h5>Objeto Impuesto</h5>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                        <mat-form-field [floatLabel]="'always'">
                            <!-- <mat-label>Objeto Impuesto</mat-label> -->
                            <mat-select placeholder='Seleccione' formControlName="ObjetoImpuesto">
                                <mat-option *ngFor="let item of lstObjetoImpuesto"
                                    [value]="item.id">
                                    {{item.attributes.valor}}-{{item.attributes.nombre}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <span class="text-12 rojo-error" *ngIf="!valObjetoImpuesto" id="mat-hint-0"><strong>*Este campo es obligatorio.</strong></span>
                    </div>
            
                    <div class='col-sm-12 col-md-12 col-xl-12 mt-8'>
                        <h5>Impuestos Federales</h5>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                        <mat-label>Selecciona únicamente los impuestos que necesite tu
                            producto</mat-label>
                    </div>

                    <div class="col-sm-12">
                        <div class="row">
                            <div class='col-sm-12 col-md-6 col-xl-6 mt-2'>
                                <mat-form-field [floatLabel]="'always'">
                                    <mat-label>IVA</mat-label>
                                    <mat-select placeholder='Seleccione' formControlName="iva">
                                        <mat-option [value]="0">-</mat-option>
                                        <mat-option *ngFor="let iva of lstIva" [value]="iva.id">
                                            {{iva.attributes.nombre}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class='col-sm-12 col-md-6 col-xl-6 mt-2'>
                                <mat-form-field [floatLabel]="'always'">
                                    <mat-label>IVA RET </mat-label>
                                    <mat-select placeholder='Seleccione' formControlName="ivaRet"
                                        [disabled]="mostrarIvaRet">
                                        <mat-option [value]="0">-</mat-option>
                                        <mat-option *ngFor="let ivaRet of lstIva_retenido"
                                            [value]="ivaRet.id">
                                            {{ivaRet.attributes.nombre}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class='col-sm-12 col-md-6 col-xl-6 mt-2'>
                                <mat-label class="col-sm-12 col-md-4 col-xl-4 mt-2">IEPS 
                                </mat-label>
                                <mat-checkbox class="col-sm-12 col-md-4 col-xl-4 mt-2"
                                    formControlName="tasa" (change)=" GetTasa()">TASA
                                </mat-checkbox>
                                <mat-checkbox class="col-sm-12 col-md-4 col-xl-4 mt-2"
                                    formControlName="cuota" (change)=" getCuota()">CUOTA
                                </mat-checkbox>
                                <mat-form-field *ngIf="mostrar" [floatLabel]="'always'">
                                    <mat-select placeholder='Seleccione' (selectionChange)="selecctionIeps($event.value)" formControlName="iepsTasa">
                                        <!-- <mat-option [value]="{'idIEPS': 0, 'nombre': '0'}">NO APLICA</mat-option> -->
                                        <!-- <mat-option [value]="ieps.id">NO APLICA</mat-option> -->
                                        <mat-option [value]="0">-</mat-option>
                                        <mat-option *ngFor="let ieps of lstIeps" [value]="ieps.id">
                                            {{ieps.attributes.nombre}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field *ngIf="!mostrar" [floatLabel]="'always'">
                                    <input matInput placeholder="Ej. 0.005, 0.03"
                                        formControlName="iepsCuota"
                                        mask="99999999999999.000"
                                        (input)="onSearchChange($event.target.value)">
                                </mat-form-field>
                                <span *ngIf="errorNaN" class="text-12 rojo-error" id="mat-hint-0">Por favor, escribe un valor mayor o igual a 0.</span>
                            </div>

                            <div class='col-sm-12 col-md-6 col-xl-6 mt-2'>
                                <mat-form-field [floatLabel]="'always'" class="mt-3">
                                    <mat-label>ISR</mat-label>
                                    <mat-select placeholder='Seleccione' formControlName="isr">
                                        <mat-option [value]="0">-</mat-option>
                                        <mat-option *ngFor="let isr of lstIsr" [value]="isr.id">
                                            {{isr.attributes.nombre}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-8'
                        style='margin-bottom: 20px;'>
                        <h5>Catálogos del SAT <span class="text-12 rojo-error">*</span></h5>
                    </div>

                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="row">
                                    <!-- ================================ INICIO CLAVES-->
                                    <div class="col-sm-12">
                                        <p class="text-14">Asocia tu producto al <strong>CATÁLOGO del SAT</strong> Busca tu CLAVE, escribela en el campo de abajo, espera opciones y selecciona una </p>
                                        <!-- (8 caracteres) -->
                                    </div>

                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-12" *ngIf="!rowsetshowClave">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <mat-form-field [floatLabel]="'always'" class="fuse-mat-emphasized-affix">
                                                            <div class="input-container">
                                                                <input
                                                                    style="width: 280px;"
                                                                    matInput
                                                                    id="myInputBusquedaClave"
                                                                    name="myInputBusquedaClave"
                                                                    (change)="GetSelProductoServicio($event, 0)"
                                                                    (keyup.enter)="GetSelProductoServicio($event, 0)"
                                                                    placeholder="Palabras clave de búsqueda"
                                                                    [disabled]="!loadCatalogoClaveSat"
                                                                />
                                                                <div class="spinner-container" *ngIf="!loadCatalogoClaveSat">
                                                                    <mat-progress-spinner
                                                                        diameter="20"
                                                                        mode="indeterminate"
                                                                        class="spinner"
                                                                    ></mat-progress-spinner>
                                                                    <span class="loading-text">Cargando catálogo...</span>
                                                                </div>
                                                                <mat-icon>search</mat-icon>
                                                            </div>
                                                            <mat-hint
                                                                class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35"
                                                                id="mat-hint-0"
                                                            >
                                                                Sí no encuentras la clave que deseas utilizar buscala
                                                                <a (click)="btnClave()">aquí</a>
                                                            </mat-hint>
                                                        </mat-form-field>
                                                        
                                                        
                                                        <!-- <mat-form-field [floatLabel]="'always'" class="fuse-mat-emphasized-affix">
                                                            <input matInput id="myInputBusquedaClave" name="myInputBusquedaClave" (change)="GetSelProductoServicio($event,0)" (keyup.enter)="GetSelProductoServicio($event,0)"
                                                            placeholder="Palabras clave de búsqueda" [disabled]="!loadCatalogoClaveSat">
                                                            <mat-icon >search</mat-icon>
                                                            <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no encuentras la clave que deseas utilizar buscala <a (click)="btnClave()">aquí</a></mat-hint>
                                                        </mat-form-field> -->
                                                        <span class="text-12 rojo-error" *ngIf="!isValidClave" id="mat-hint-0"><strong>*Este campo es obligatorio.</strong></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-12 col-md-12" *ngIf="rowsetshowClave">
                                                <mat-form-field class="example-full-width" appearance="fill"
                                                    [floatLabel]="'always'">
                                                    <input type="text" id="myInputClave" name="myInputClave" placeholder="seleccione una opción"
                                                        aria-label="Number" matInput [formControl]="myControl"
                                                        required [matAutocomplete]="auto">
                                                    <mat-autocomplete #auto="matAutocomplete"
                                                        [displayWith]="displayFn">
                                                        <ng-container *ngIf="options">
                                                            <!-- <mat-option *ngFor="let option of filteredOptions | async" [value]="option"> -->
                                                            <mat-option *ngFor="let option of options"
                                                                [value]="option">
                                                                {{option?.attributes.clave}}-{{option?.attributes.descripcion}}
                                                                <!-- {{ displayFn(option) }} -->
                                                            </mat-option>
                                                        </ng-container>
                                                    </mat-autocomplete>
                                                    <mat-error *ngIf="myControl.invalid">*Este campo es obligatorio.</mat-error>
                                                    <mat-icon svgIcon="mat_solid:close" (click)="eraseClaveSat()"></mat-icon>
                                                    <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no encuentras la clave que deseas utilizar buscala <a (click)="btnClave()">aquí</a></mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="row">
                                    <!-- ======================== -->
                                    <div class="col-sm-12">
                                        <p class="text-14">Define la Unidad de tu producto Busca tu <strong>UNIDAD</strong>, escribela en el campo, espera opciones y selecciona una </p>
                                        <!-- (De 2 a 3 caracteres) -->
                                    </div>

                                    <div class="col-sm-12 ">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-12" *ngIf="!rowsetshowUnidad">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <mat-form-field [floatLabel]="'always'">
                                                            <input matInput (change)="GetSelUnidadMedia($event,0)" (keyup.enter)="GetSelUnidadMedia($event,0)" id="myInputBusquedaUnidad" name="myInputBusquedaUnidad"
                                                            placeholder="Palabras clave de búsqueda">
                                                            <mat-icon >search</mat-icon>
                                                            <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no encuentras la clave que deseas utilizar buscala <a (click)="btnUnidad()">aquí</a></mat-hint>
                                                        </mat-form-field>
                                                        <span class="text-12 rojo-error" *ngIf="!isValidUnidad" id="mat-hint-0"><strong>*Este campo es obligatorio.</strong></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-12" *ngIf="rowsetshowUnidad">
                                                <mat-form-field class="example-full-width" appearance="fill"
                                                    [floatLabel]="'always'">
                                                    <input type="text" placeholder="seleccione una opción"
                                                        id="myInputUnidad" name="myInputUnidad"
                                                        aria-label="Number" matInput
                                                        [formControl]="myControlUnidadMedida" required
                                                        [matAutocomplete]="autoUnidad">
                                                    <mat-autocomplete #autoUnidad="matAutocomplete"
                                                    (optionSelected)="onUnidadMedidaSelected($event)"
                                                        [displayWith]="displayFnUnidadMedida">
                                                        <ng-container *ngIf="unidadMedida">
                                                            <!-- <mat-option *ngFor="let optiones of filteredUnidadMedida | async" [value]="optiones"> -->
                                                            <mat-option *ngFor="let optiones of unidadMedida"
                                                                [value]="optiones">
                                                                {{optiones.attributes.clave}}-{{optiones.attributes.nombre}}
                                                            </mat-option>
                                                        </ng-container>
                                                    </mat-autocomplete>
                                                    <mat-error *ngIf="myControlUnidadMedida.invalid">*Este campo es
                                                        obligatorio.</mat-error>
                                                    <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no encuentras la clave que deseas utilizar buscala <a (click)="btnUnidad()">aquí</a></mat-hint>
                                                    <mat-icon svgIcon="mat_solid:close" (click)="eraseUnidad()"></mat-icon>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class='col-sm-12 col-md-12 col-xl-12 mt-2'>
                        <h5 class="" style="margin-top:20px; margin-bottom:20px;">OPCIONALES</h5>
                    </div>

                    <div class='col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2'>
                        <form [formGroup]="numeroPedimentoForm">
                            <div formArrayName="numeroPedimentos">
                              <div *ngFor="let pedimento of numeroPedimentos.controls; let i = index">
                                <div [formGroupName]="i" class="form-row">
                                  <mat-form-field appearance="fill" class="input-field">
                                    <mat-label>Número de Pedimento</mat-label>
                                    <input matInput formControlName="numeroPedimento" placeholder="Ej. 12 34 5678 9012345" (input)="imprimirNumeroPedimento($event)" minlength="18" maxlength="18" />
                                    <mat-error *ngIf="numeroPedimentos.controls[i].controls.numeroPedimento.errors">
                                      El número de pedimento es inválido.
                                    </mat-error>
                                    <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Ejemplo: 12 34 5678 9012345</mat-hint>
                                  </mat-form-field>
                                  <button mat-icon-button color="warn" (click)="eliminarNumeroPedimento(i)">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <button mat-raised-button color="primary" type="button" (click)="agregarNumeroPedimento()">Agregar Pedimento</button>
                        </form>
                    </div>

                    <div class='col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-8'>
                        <div class="demo-button-container">
                            <button mat-button type="button" (click)="addData()" #boton2
                                class="" style="background-color:none;">
                                <span style="color:blue; margin-left: -15px;"><button
                                        mat-mini-fab color="primary"
                                         type="button">+</button>
                                    Add Impuestos Locales</span>
                            </button>
                        </div>

                        <table mat-table [dataSource]="dataSource1" #datosTabla1
                            class=" demo-table col-sm-12 col-md-12 col-xl-12 mt-2">
                            <!-- Position Column -->
                            <ng-container matColumnDef="position"
                                class="col-sm-12 col-md-12 col-xl-12 mt-2">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let index = index;" class="pd-lf-0 mt-10"><button
                                        mat-mini-fab color="warn" type="button"
                                        (click)="removeData(index)">x</button></td>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="nombre"
                                class="col-sm-12 col-md-12 col-xl-12 mt-2">
                                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                <td mat-cell *matCellDef="let index = index">
                                    <mat-form-field [floatLabel]="'always'"
                                        class="pd-lf-0 mt-10">
                                        <input matInput placeholder="Nombre" #nombre
                                            (change)="imprimirNombre($event,index)"
                                            oninput="this.value = this.value.toUpperCase()"
                                            [value]="dataSource1[index].nombre">
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- Weight Column -->
                            <ng-container matColumnDef="tasa"
                                class="col-sm-12 col-md-12 col-xl-12 mt-2">
                                <th mat-header-cell *matHeaderCellDef>Tasa</th>
                                <td mat-cell *matCellDef="let index = index">
                                    <mat-form-field [floatLabel]="'always'"
                                        class="pd-lf-0 mt-10">
                                        <input matInput class="text-right"
                                            placeholder="Tasa" #tasa 
                                            (change)="imprimirTasa($event,index)"
                                            maxlength="10" [value]="dataSource1[index].tasa | number:'1.4-4'"> 
                                    </mat-form-field>
                                    
                                    <mat-error *ngIf="tasaa.invalid">*Por favor, escribe un
                                        valor menor o igual a 0.9999.</mat-error>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="monto"
                                class="col-sm-12 col-md-12 col-xl-12 mt-2">
                                <th mat-header-cell *matHeaderCellDef>Monto</th>
                                <td mat-cell *matCellDef="let index = index">
                                    <mat-form-field [floatLabel]="'always'"
                                        class="pd-lf-0 mt-10">
                                        <input matInput class="text-right"
                                            placeholder="Monto" #monto
                                            (change)="imprimirMonto($event, index)" min="0"
                                            maxlength="16" [value]="dataSource1[index].monto | number:'1.2-2'"
                                           >
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- Symbol Column -->
                            <ng-container matColumnDef="typo"
                                class="col-sm-12 col-md-12 col-xl-12 mt-2">
                                <th mat-header-cell *matHeaderCellDef>Tipo</th>
                                <td mat-cell *matCellDef="let index = index">
                                    <mat-form-field [floatLabel]="'always'"
                                        class="pd-lf-0 mt-10">
                                        <!-- <input matInput placeholder="Typo" #typo (change)="imprimirTypo($event,index)"> -->
                                        <mat-select [value]='dataSource1[index].typo'
                                            placeholder='Seleccione' #typo
                                            (selectionChange)="imprimirTypo($event.value,index)">
                                            <mat-option
                                                *ngFor="let impuesto of lstTipoImpuesto"
                                                [value]="impuesto.id">
                                                {{impuesto.attributes.nombre}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="col-6">
                    <div class="row">

                    </div>
                </div>

                <div class="col-12 d-flex justify-content-end f12" style="margin-top:30px; margin-bottom:20px; display: none;">

                </div>

            </form>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Cerrar</button>
    <button *ngIf="modeBtn == 1" mat-flat-button color="accent" cdkFocusInitial (click)="insertProducto();">Guardar</button>
    <button *ngIf="modeBtn == 2" mat-flat-button color="accent" [disabled]="!loadCatalogoClaveSat" cdkFocusInitial (click)="ActualizarProducto();">Actualizar</button>
</div>
